import { render, staticRenderFns } from "./calculate.vue?vue&type=template&id=6b55fc2a&scoped=true&"
import script from "./calculate.vue?vue&type=script&lang=js&"
export * from "./calculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55fc2a",
  null
  
)

export default component.exports